module.exports = __webpack_public_path__ + "static/media/ic_round-star.8afe757b.svg";